import request from '@/utils/request'

// export function getAllNews(){
//   return request({
//     url:'/api/wqproject_company/index.php/66?app=public&mod=RECnews&act=getRECnews',
//     method:'get'
//   })
// }
// export function getNewById(companyId,newsId){
//   return request({
//     url:`/api/wqproject_company/index.php/66?app=public&mod=RECnews&act=getRECnewsDetail&company_id=${companyId}&news_id=${newsId}&is_post=1`,
//     method:'get'
//   })
// }

// import request from '@/utils/request'

export function getAllNews(){
  return request({
    url:'http://i-wq.net/wqproject_company/index.php/66?app=public&mod=RECnews&act=getRECnews',
    method:'get'
  })
}
export function getNewById(companyId,newsId){
  return request({
    url:`http://i-wq.net/wqproject_company/index.php/66?app=public&mod=RECnews&act=getRECnewsDetail&company_id=${companyId}&news_id=${newsId}&is_post=1`,
    method:'get'
  })
}